export const getTelClinic = (areaName) => {
  return {
    'tokyo': '医療法人社団新拓会',
    'kanagawa': '医療法人おひさま会',
    'chiba': '医療法人社団MXPG',
    'saitama': '医療法人社団MXPG',
    'aichi': '医療社団法人広域白報会',
    'osaka': '医療法人笑顔会',
    'hyogo': '医療法人笑顔会',
    'kyoto': '医療法人おひさま会',
    'nara': '医療法人おひさま会',
    'fukuoka': '医療法人社団ビーンズ',
  }[areaName]
}

export const getEndPoint = (mode) => {
  return {
    'production' : {
      'base_url': 'https://backend.fastdoctor.jp/',
      'api':  'https://dkwzkcndacwdn.cloudfront.net/api/web_statuses.json',
      'contact':  'https://backend.fastdoctor.jp/api/receptions.json',
      'city':  'https://backend.fastdoctor.jp/api/cities.json',
      'area':  'https://backend.fastdoctor.jp/api/areas/check.json',
      'online_status': 'https://dkwzkcndacwdn.cloudfront.net/api/receptions/online_examinations.json'
    },
    'development' : {
      'base_url': 'https://fast-doctor-manager.herokuapp.com/',
      'api':  'https://fast-doctor-manager.herokuapp.com/api/web_statuses.json',
      'contact':  'https://fast-doctor-manager.herokuapp.com/api/receptions.json',
      'city':  'https://fast-doctor-manager.herokuapp.com/api/cities.json',
      'area':  'https://fast-doctor-manager.herokuapp.com/api/areas/check.json',
      'online_status': 'https://fast-doctor-manager.herokuapp.com/api/receptions/online_examinations.json'
    }
  }[mode]
}

export const UPDATE_TIME = 5000;

export const TEL_CVR = '0120-407-622'; // index.pugにも電話番号変数の記述有り

// TODO:似たようなエリア宣言
// URLで電話番号判定
export const areaTelNameList = [
  'tokyo',
  'kanagawa',
  'saitama',
  'chiba',
  'kansai',
  'tokai',
  'kyusyu',
];

// TODO:似たようなエリア宣言
// URLで電話番号判定
export const getTelNumber = (areaTelName) => {
  return {
    'tokyo': '0120-407-622',
    'kanagawa': '0120-695-689',
    'saitama': '0120-695-661',
    'chiba': '0120-695-687',
    'kansai': '0120-684-513',
    'tokai': '0120-695-667',
    'kyusyu': '0120-695-632',
  }[areaTelName]
}
